import { render, staticRenderFns } from "./FiltersPlayers.vue?vue&type=template&id=542e47b5&scoped=true&"
import script from "./FiltersPlayers.vue?vue&type=script&lang=js&"
export * from "./FiltersPlayers.vue?vue&type=script&lang=js&"
import style0 from "./FiltersPlayers.vue?vue&type=style&index=0&id=542e47b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e47b5",
  null
  
)

export default component.exports